<template>
  <div>
    <div class="tagContent">
      <div :key="index" v-for="(item, index) in selectTagList" class="tag" :style="{ backgroundColor: item.color }">
        <i class="el-icon-error" @click="tagClose(item, index)" v-hasPermi="[hasPermi]"></i>
        <div class="tagLeft" :style="{ color: item.color }">
          <img src="@/assets/images/sys/bqgl/tag-icon.png" alt="">
        </div>
        <div class="tagRight">{{ item.bqLabel }}</div>
      </div>
      <div>
        <div class="button-new-tag" @click="isSelectBq = true" v-hasPermi="[hasPermi]">+</div>
      </div>
    </div>
    <bqSelect ref="bqSelect" :isDialog="isSelectBq" :bqLxCode="bqLxCode" :tagData="tagDataList"
      @selectTagListChange="saveSelectTage" @handleClose="isSelectBq = false" @saveSelectTage="saveSelectTage"></bqSelect>
  </div>
</template>

<script>
import bqSelect from '@/views/sys/bqgl/components/bqSelect/bqSelect.vue'
export default {
  components:{
    bqSelect,
  },
  props: {
    bqList: {
      type: Array,
      default: () => []
    },
    hasPermi:{
      type:String,
      default:''
    },
    bqLxCode:{
      type:String,
      default:'syrk'
    }
  },
  data() {
    return {
      selectTagList: [],//选择的标签列表
      isSelectBq: false,//标签选择
      // tagDataList: [],
    }
  },
  watch:{
    bqList:{
      handler(){
        // this.$refs.bqSelect.getTree();
      },
      deep:true,
    }
  },
  computed:{
    tagDataList:{
      get: function(){
        return this.bqList||[];
      },
      set: function(newValue) {}
    }
  },
  methods: {
    // 选择的标签
    saveSelectTage(e) {
      this.selectTagList = e;
      this.tagDataList = e.map(item => item.bqValue) || [];//保存标签值
      this.$emit('saveSelectTage',e)
      this.isSelectBq = false;
    },
    // 标签删除
    tagClose(item, index) {
      this.$refs.bqSelect.handleTagClose(item, index);
      this.$emit('tagClose',this.selectTagList)
    },
  },
}
</script>

<style lang="scss" scoped>
.tagContent {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: flex-start;
}

.button-new-tag {
  cursor: pointer;
  margin-left: 10px;
  width: 24px;
  height: 24px;
  border: 1px solid #ddd;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
}
</style>